module.exports = __webpack_public_path__ + "media/images/realty-one-group-gold-e3f36777.png";